export enum DayOfMonthRuleEnum {
  NA,
  'Last Monday',
  'Last Tuesday',
  'Last Wednesday',
  'Last Thursday',
  'Last Friday',
 'Last Saturday',
  'First Monday',
  'First Tuesday',
  'First Wednesday',
  'First Thursday',
  'First Friday',
  'First Saturday',
  'Last Day',
  '2nd Last Day'
}

export namespace DayOfMonthRuleEnum {
  export function values() {
    return Object.keys(DayOfMonthRuleEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

